import React from "react";
import { connect } from "react-redux";
import * as actions from "../../actions";
import { CSS } from "../../css/tab_datatable";
import Style from "style-it";
import EkoDataTable from "../../components/elements/EkoDataTable";
import { FETCH_TRANSPORTATION_CONTRACTS } from "../../actions/types";
import Api from "../../util/Api";
import { toastr } from "react-redux-toastr";
import Util from "../../util/Util";
import EkoModal from "../../components/elements/EkoModal";

class TransportationContractList extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      transportationContracts: [],
      receiptModal:false,
      receiptModalId:0
    };
  }

  componentWillMount() {
    this.fetchData();
  }

  fetchData() {
    this.props.fetchData(
      "/transportationContract/list",
      FETCH_TRANSPORTATION_CONTRACTS,
    );
  }

  openInsert(menuItem) {
    if (menuItem === 1) {
      this.props.router.push("/dashboard/salesInvoice/add/toCustomer");
    } else if (menuItem === 2) {
      this.props.router.push("/dashboard/salesInvoice/add/toSupplier");
    } else if (menuItem === 3) {
      this.props.router.push("/dashboard/salesInvoice/zreports/add");
    } else if (menuItem === 4) {
      this.props.router.push("/dashboard/salesInvoice/proforma/add");
    } else if (menuItem === 5) {
      this.props.router.push("/dashboard/salesInvoice/otherSales/add");
    } else if (menuItem === 6) {
      this.props.router.push("/dashboard/salesInvoice/soleprofv2/add");
    } else if (menuItem === 7) {
      this.props.router.push("/dashboard/salesInvoice/salesShipment/add");
    } else if (menuItem === 9) {
      this.props.router.push("/dashboard/salesInvoice/transportationContract/add");
    }
  }

  openUpdate(row) {
    this.props.router.push(
      "/dashboard/salesInvoice/transportationContract/edit/" + row.id,
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.transportationContracts) {
      this.setState({
        transportationContracts: nextProps.transportationContracts,
      });
    }
  }

  onDelete(row) {
    Api.delete("/transportationContract/" + row.id, (response, error) => {
      if (!error && response && response.status === "ok") {
        toastr.success("Başarıyla Silindi");
        this.fetchData();
      } else {
        toastr.error(error && error.message ? error.message : "Silinemedi");
      }
    });
  }

  get items() {
    const companySettings = JSON.parse(localStorage.getItem("company_settings"));
    var user_json = JSON.parse(localStorage.getItem("user"));
    var list = [];
    if (user_json.company_type == 9 || user_json.company_type == 6) {
      window.location.replace("/dashboard/salesInvoice/soleprofv2s");
    }
    if (user_json.company_type == 9 || user_json.company_type == 6) {
      list = [
        {
          id: 5,
          link: "/dashboard/salesInvoice/soleprofv2s",
          title: "Serbest Meslek Makbuzu",
        },
        {
          id: 2,
          link: "/dashboard/salesInvoice/zreports",
          title: "Z Raporları",
        },
        {
          id: 3,
          link: "/dashboard/salesInvoice/proformas",
          title: "Teklifler/Siparişler",
        },
        {
          id: 4,
          link: "/dashboard/salesInvoice/otherSales",
          title: "Diğer Gelirler",
        },
      ];
    } else {
      list = [
        {
          id: 1,
          link: "/dashboard/salesInvoice",
          title: "Satışlar",
        },

        {
          id: 2,
          link: "/dashboard/salesInvoice/zreports",
          title: "Z Raporları",
        },
        {
          id: 3,
          link: "/dashboard/salesInvoice/proformas",
          title: "Teklifler/Siparişler",
        },
        {
          id: 4,
          link: "/dashboard/salesInvoice/otherSales",
          title: "Diğer Gelirler",
        },
        {
          id: 9,
          link: "/dashboard/salesInvoice/transportationContract",
          title: "Taşıma Sözleşmesi",
        },
      ];
      if (companySettings.show_z_reports !== 1) {
        list = list.filter((item) => item.id !== 2);
      }
      if (companySettings.show_orders_quotes !== 1) {
        list = list.filter((item) => item.id !== 3);
      }
      if (companySettings.show_other_incomes !== 1) {
        list = list.filter((item) => item.id !== 4);
      }
            if (companySettings.show_transportation_contract !== 1) {
        list = list.filter(item => item.id !== 9);
      }
      if (Util.companyModules(2) === true) {
        list.push({
          id: 7,
          link: "/dashboard/salesInvoice/salesShipment",
          title: "Sevk İrsaliyesi",
        });
      }
      if (Util.companyModules(7) === true) {
        list.push({
          id: 8,
          link: "/dashboard/SalesInvoice/SalesInvoiceRetailSales",
          title: "Perakende Satış",
        });
      }
    }
    return list;
  }

  transportationContract(row) {
    this.setState({
      receiptModal: true,
      receiptModalId: row.id,
    });
  }

  render() {
    const companySettings = JSON.parse(localStorage.getItem("company_settings"));
    const insertMenux = this.props.viewOptions
      ? this.props.viewOptions.sales.addRecordMenu
      : false;
    if (insertMenux != false) {
      var user_json = JSON.parse(localStorage.getItem("user"));
      if (user_json.company_type == 9 || user_json.company_type == 6) {
        var insertMenu = insertMenux.filter(
          (obj) =>
            obj.id !== 1 && obj.id !== 2 && obj.id !== 3 && obj.id !== 4 && obj.id !== 7,
        );
        insertMenu.unshift({ id: 6, name: "Serbest Meslek Makbuzu" });
      } else {
        insertMenu = insertMenux;
      }
    }
    if (companySettings.show_z_reports !== 1) {
      insertMenu = insertMenu?.filter((item) => item.id !== 3);
    }
    if (companySettings.show_orders_quotes !== 1) {
      insertMenu = insertMenu?.filter((item) => item.id !== 4);
    }
    if (companySettings.show_other_incomes !== 1) {
      insertMenu = insertMenu?.filter((item) => item.id !== 5);
    }
      if (companySettings.show_transportation_contract !== 1) {
        insertMenu = insertMenu?.filter(item => item.id !== 9);
      }
    var apiUrl = process.env.REACT_APP_API_URL;
    apiUrl = apiUrl.substring(0, apiUrl.length-3);
    const time = new Date();
    return (
      <div>
        <a
          style={{ bottom: "6px", position: "relative", color: "grey" }}
          onClick={Util.backButton.bind(this, "/dashboard")}
        >
          <i className="fa fa-arrow-left" /> Geri Dön
        </a>

        {Style.it(
          CSS,
          <div>
            <EkoDataTable
              title="Taşıma Sözleşmesi"
              tabMenu={this.items}
              selectedTab={9}
              openInsert={this.openInsert.bind(this)}
              openUpdate={this.openUpdate.bind(this)}
              onDelete={this.onDelete.bind(this)}
              data={this.state.transportationContracts}
              insertMenu={insertMenu}
              name={"transportationContract"}
              transportationContract={this.transportationContract.bind(this)}
            />
          </div>,
        )}
        <EkoModal
                        showModal={this.state.receiptModal}
                        title="Makbuz"
                        bsSize="xlg" // xlg
                        onHide={() => {
                          this.setState({
                            receiptModal: false
                          });
                          //this.onCancel();
                        }}
                        spinner={this.state.saving}
                    >
                      <iframe
                          style={{overflow: 'visible'}}
                          ref="iframe"
                          src={apiUrl + "transportationContractReceipt/index.php?id=" + this.state.receiptModalId + "&time=" + time.getTime() + "&t=" + localStorage.getItem('token')}
                          scrolling="auto"
                          frameBorder="0"
                          width="100%"
                          height={800}
                      />
                    </EkoModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transportationContracts: state.data.transportationContracts,
    viewOptions: state.data.viewOptions,
  };
};

export default connect(mapStateToProps, actions)(TransportationContractList);
